<template>
    <div class="d-flex flex-row align-items-center justify-content-center header">
        <a href="https://www.ourcu.com/" target="_blank">
            <img src="@/assets/img-occu/logo_white.png" style="height:50px;">
        </a>
    </div>
</template>
<script>
export default {
    name: 'Header'
}
</script>